/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { useMutateUserProfile } from '../../hooks/api/useUserProfile';
import Modal from '../../components/modal/Modal';
import useModal from '../../hooks/useModal';
import AlertCustom from '../../components/alert/AlertCustom';
import Button from '../../components/button/Button';
import FormEditAbout from './FormEditAbout';

const useEditAbout = () => {
    const [isEditAbout, closeEditAbout, openEditAbout] = useModal(false);
    const [alertSuccess, closeAlertSuccess, openAlertSuccess] = useModal();

    const {
        mutate,
        // error,
        isLoading: isPostLoading
        // isSuccess
    } = useMutateUserProfile();

    const handleSubmit = values => {
        mutate(values, {
            onSuccess: () => {
                setTimeout(() => {
                    closeEditAbout();
                    openAlertSuccess();
                }, 300);
            }
        });
    };

    const modalProps = {
        isEditAbout,
        closeEditAbout,
        handleSubmit,
        alertSuccess,
        closeAlertSuccess,
        isPostLoading
    };

    const EditAboutJSX = <ModalEditAbout {...modalProps} />;

    return [openEditAbout, EditAboutJSX];
};

export default useEditAbout;

const ModalEditAbout = ({
    isEditAbout,
    closeEditAbout,
    isPostLoading,
    handleSubmit,
    alertSuccess,
    closeAlertSuccess
}) => (
    <>
        <Modal
            showModal={isEditAbout}
            closeModal={closeEditAbout}
            btnCloseModal={true}
            position="p-top"
            width="modal-md">
            <FormEditAbout
                handleSubmit={handleSubmit}
                isPostLoading={isPostLoading}
            />
        </Modal>

        <AlertCustom
            showModal={alertSuccess}
            title="Saved successfully"
            subtitle="Information has been saved successfully"
            typeAlert="success">
            <>
                <Button
                    classs="btnMain"
                    text="Ok"
                    onClick={() => {
                        closeAlertSuccess();
                    }}
                />
            </>
        </AlertCustom>
    </>
);
